import axios from "axios";  // plain axios, NOT apiClient
import { getFingerprint } from "./fingerPrintService";
import { GLOBALSETTINGS } from "../data/constants";

const baseAPIUrl = process.env.REACT_APP_API_URL + "/api";

export const requestNonce = async () => {
  const fingerprint = getFingerprint();

  // Use plain axios here to avoid triggering apiClient interceptors — which also means
  // apiClient's timeout does not apply, so it has to be set explicitly. This call runs ahead
  // of every nonce-protected endpoint (sign-in included), so an unbounded hang here stalls
  // login itself.
  const response = await axios.post<{ nonce: string }>(
    `${baseAPIUrl}/nonce/request`,
    { fingerprint },
    {
      headers: { "Content-Type": "application/json" },
      timeout: GLOBALSETTINGS.API_TIMEOUT_MS,
    }
  );

  return {
    nonce: response.data.nonce,
    fingerprint
  };
};